import { infiniteLoopProtectInstrument } from './infinite-loop-protect-instrument/infinite-loop-protect-instrument';

export const getTransformedJsCode = (jsCode: string): string => {
	try {
		return infiniteLoopProtectInstrument(jsCode);
	} catch (err) {
		return jsCode;
	}
};
